import React from "react";

export function SearchBar( { setSearchValue }: { setSearchValue: (search: string) => void } ) {

    const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(event.target.value);
    }

    return (
        <input className="tutor-search-bar"
            type="search" name="search" placeholder="Search" onChange={handleTextChange}/>
    );
}